const getclassNames = (existing: string, ...additional: string[]): string => {
    const existingsClasses = (existing && existing.split(' ')) || [];

    return [
        ...existingsClasses,
        ...additional
    ].join(' ');
};

export default getclassNames;